import { createTheme, responsiveFontSizes } from '@mui/material';
import { MuiAccordion } from './components/mui-accordion';
import { MuiAccordionSummary } from './components/mui-accordion-summary';
import { MuiAutocomplete } from './components/mui-autocomplete';
import { MuiBadge } from './components/mui-badge';
import { MuiButton } from './components/mui-button';
import { MuiChip } from './components/mui-chip';
import { MuiFilledInput } from './components/mui-filled-input';
import { MuiIcon } from './components/mui-icon';
import { MuiListItemButton } from './components/mui-list-item-button';
import { MuiListItemIcon } from './components/mui-list-item-icon';
import { MuiListItemText } from './components/mui-list-item-text';
import { MuiListSubheader } from './components/mui-list-subheader';
import { MuiPaper } from './components/mui-paper';
import { MuiSwitch } from './components/mui-switch';
import { MuiTab } from './components/mui-tab';
import { MuiTabs } from './components/mui-tabs';
import { MuiTextField } from './components/mui-text-field';
import { vyTypography } from './typography';
import { vyPalette } from './vyPalette';
import { MuiIconButton } from './components/mui-icon-button';

export const vyTheme = responsiveFontSizes(
  createTheme({
    palette: vyPalette,
    typography: vyTypography,
    components: {
      MuiListItemButton,
      MuiListSubheader,
      MuiAutocomplete,
      MuiListItemIcon,
      MuiAccordion,
      MuiAccordionSummary,
      MuiFilledInput,
      MuiTextField,
      MuiButton,
      MuiSwitch,
      MuiPaper,
      MuiListItemText,
      MuiChip,
      MuiTabs,
      MuiTab,
      MuiBadge,
      MuiIcon,
      MuiIconButton,
    },
  }),
);
